import { Skeleton } from "@/components/ui/skeleton";
import { stripHtmlTags } from "@/utils/format";
import type { Correction } from "@/queries/formality-request";

interface FormCorrectionGeneralCommentProps {
  isFetching: boolean;
  correction: Correction | null;
}

export const FormCorrectionGeneralComment = ({
  isFetching,
  correction,
}: FormCorrectionGeneralCommentProps) => {
  if (isFetching) {
    return <Skeleton className="w-full h-16 rounded-lg" />;
  }

  if (
    !correction?.comments ||
    (correction?.comments?.length ?? 0) === 0 ||
    !correction?.comments?.[0]?.text
  ) {
    return null;
  }

  return (
    <div className="bg-surface-warning-accent-quiet border rounded-lg border-contextual-warning-quiet p-2 flex flex-col gap-1">
      <h1 className="text-h1 text-heading text-size-body-sm leading-2xl">
        Comentario general
      </h1>
      <p className="font-body text-body text-size-body whitespace-pre-line text-justify wrap-break-words min-w-0">
        {stripHtmlTags(correction?.comments?.[0]?.text)}
      </p>
    </div>
  );
};
